import { Typography } from '@cp/ds/src/components/typography';
import React from 'react';
import { RoutedLink as Link } from 'src/shared/ui/link';
import { Tokens } from './const';

export interface TitleProps extends React.PropsWithChildren {
  url?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}
export const Title = (props: TitleProps) => {
  return props.url ? (
    <Link href={props.url} onClick={props.onClick} sx={{ typography: 'h3', color: Tokens.textColor() }} underline={false}>
      {props.children}
    </Link>
  ) : (
    <Typography onClick={props.onClick} sx={{ color: Tokens.textColor() }} variant="h3">
      {props.children}
    </Typography>
  );
};
